import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CdkDragDrop, CdkDragStart, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { VesselsService } from '../../../../../services/vessels.service';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { DistributionDataService } from '../../../../../services/distributionData.service';
import { StorageService } from '../../../../../services/storage.service';
import { PoolingPortalService } from '../../../../../services/pooling-portal.service';
import { AddShipModel, Setting } from '../../../../../interface/fleetList.interface';
import { Subscription } from 'rxjs'; 
import { ToasterService } from 'src/app/services/toaster.service';
@Component({
  selector: 'app-add-ship',
  templateUrl: './add-ship.component.html',
  styleUrls: ['./add-ship.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddShipComponent {


  @Input() iNewShipForm: any;
  @Input() tab: any;
  @Input() subpool: any;
  @Output() closeShip = new EventEmitter();

    setting:Setting  = {
    showCloseIcon: false, 
    backdropClick: false
  } 

  viewModel: AddShipModel  = {
    searchText:'',
    searchInput:true,
    fleet: '',
    addShipSubmit: false,
    owners:[],
    minDate: new Date(),
    imosNew:[],
    imosNewTemp:[],
    selectdShip:[],
    addShipList:[],
    shipsFromDragListTemp:[],
    shipsFromdragListCopyTemp:[],
    shipsData:[],
    
  }
  public ShipForm: UntypedFormGroup;
  subscription: Subscription;  

  constructor(
    private fb: UntypedFormBuilder,
    private _vesselService: VesselsService,
    public datepipe: DatePipe,
    private toasterService: ToasterService,
    private _distributionDataService: DistributionDataService,
    private _poolingPortalService: PoolingPortalService,
    private _storageService: StorageService

  ) {
  }
  ngOnInit() {
    
    let date = new Date();
    this.viewModel.minDate = new Date((date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + (date.getDate()));
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.viewModel.fleet = fleet;
          this.createShipForm();
          this.getOwnerList();
          this.getVessels('imos');
      }
    )
  }

  getOwnerList() {
    this._distributionDataService.getOwnerList(this.viewModel.fleet)
      .subscribe({
        next: (res:any) => {
          this.viewModel.owners = res.data.getOwnersList.data;
        }
      });
  }

  createShipForm() {
    this.ShipForm = this.fb.group({
      ships: this.fb.array([]),
    });
  }

  get f() { return this.ShipForm.controls; }

  ships(): UntypedFormArray {
    return this.ShipForm.get("ships") as UntypedFormArray
  }

  get shipFormGroups() {
    return this.ShipForm.get('ships') as UntypedFormArray
  }



  addShipForm(data: any): UntypedFormGroup {
    
    return this.fb.group({
      vslOwner: [(data.vslOwner) ? data.vslOwner : '', Validators.required],
      effectiveForm: ['', Validators.required],
      poolPoint: [(data.poolPoint) ? data.poolPoint : '', [Validators.required, Validators.pattern("^[0-9]{0,3}(([\\.]{1}[0-9]{0,3})|())$")]],
      subPool: [(this.tab != 'all') ? this.tab : '', Validators.required],
      vslClass: [(data.vslType) ? data.vslType : ''],
      vslCode: [(data.vslCode) ? data.vslCode : ''],
      fleet: [''],
      isNew: [true],
      vslName: [this.convertFirstLetterToUpperCase(data.vslName), Validators.required],
      vslNumber: [data.vslNumber, Validators.required],
    })
  }
  addShip(data: any) {
    this.viewModel.addShipSubmit = false;
    this.ships().push(this.addShipForm(data));
  }


  drop(event: CdkDragDrop<string[]>, name: any) {
    if (event.item.element.nativeElement.classList.contains('selected')) {
      this.multiDrag.dropListDropped(event);
      if (name == 'addShip') {
        this.viewModel.shipsFromDragListTemp.forEach((el: string) => {
          let result: any = this.viewModel.imosNew.filter(s => s.vslNumber == el);
          this.addShip(result[0]);
        });
      }
    }
    else {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      }
      if (event.container.data[0] && this.viewModel.addShipList.includes(event.container.data[0])) {
        let result: any = this.viewModel.imosNew.filter(s => s.vslNumber == event.container.data[0]);
        this.addShip(result[0]);
      }
    }
    this.viewModel.shipsFromDragListTemp = [];
    this.viewModel.shipsFromdragListCopyTemp = [];
  }


  getVessels(value: string) {
    let formData = {"fleet": this.viewModel.fleet};
    this._vesselService.getAddSubpoolVessels(formData)
      .subscribe({
        next: (res: any) => {
          this.viewModel.shipsData = [];
          this.viewModel.imosNew = res.data.getAddVesselList.data;
        
          this.viewModel.imosNewTemp = res.data.getAddVesselList.data;
          this.viewModel.imosNew.forEach((ele: any) => {
            let vslNumberExist:any = this.viewModel.shipsData.find((x:any) =>   x.id  === ele.vslNumber );
       
            if (ele.vslName && !vslNumberExist) {
              let name = this.convertFirstLetterToUpperCase(ele.vslName) + ' (' + ele.vslNumber + ')';
              this.viewModel.shipsData.push({ id: ele.vslNumber , name: name });
              console.log("1",this.viewModel.shipsData)
            }
          });
        }
      });
  }

  convertFirstLetterToUpperCase(str: any) {
    let splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }




  multiSelect = {
    longPressTime: 500, // in ms unit
    verifyLongPress: 0,
    multiSelect: false,
    verifyDragStarted: false,
    ctrlMode: false,
    firstContainer: null as unknown as HTMLElement,

    selectDrag(el: HTMLElement) {
      while (!el.classList.contains('cdk-drag')) {
        el = el.parentElement as HTMLElement;
      }
      return el;
    },

    mouseDown(e: Event) {
      let target = this.selectDrag(e.target as HTMLElement);
      let ctrlKey = (e as KeyboardEvent).ctrlKey;

      if (this.multiSelect) {
        // If multiSelect is enabled

        /* The responsibility for removing only the first ".selected" has to be with mouseDown and not with mouseUp.
           if not you can't add the first one */

        // Remove
        let allSelected = document.querySelectorAll('.selected').length;
        if (
          allSelected == 1 &&
          target.classList.contains('selected') &&
          (this.ctrlMode ? ctrlKey : true)
        ) {
          // If only have one ".selected" and it was clicked
          target.classList.remove('selected', 'last'); // remove ".selected" and ".last"
          this.multiSelect = false; // turns off multiSelect
        }
      } else {
        // If multiSelect is disabled
        // Do this
        let addSelected = () => {
          this.multiSelect = true; // enable multiSelect
          this.firstContainer = target.parentElement as HTMLElement; //saves the container of the first selected element
          target.classList.add('selected', 'last'); // and add ".selected" and ".last" to the current element clicked
        };

        // If using CTRL
        if (ctrlKey) {
          this.ctrlMode = true;
          addSelected();
        }

        // If using longPress
        this.verifyLongPress = <any>setTimeout(() => {
          // If there is a LongPress
          this.ctrlMode = false;
          addSelected();
        }, this.longPressTime); // after "longPressTime"(ms)
      }
    },

    dragStarted() {
      this.verifyDragStarted = true; // shows to mouseDown and mouseUp that Drag started
      clearTimeout(this.verifyLongPress); // cancel longPress
    },

    dragEnded() {
      this.verifyDragStarted = false; // show mouseDown and mouseUp that Drag is over
    },

    dropListDropped(e: CdkDragDrop<string[]>) {
      let el = e.item.element.nativeElement;
      if (el.classList.contains('selected')) {
        // the dragged element was of the "selected" class
        this.multiSelect = false; // disable multiSelect
      }
    },
  };

  // Multi Drag
  multiDrag = {
    // Adjusts clicked items that have ".selected" to organize together
    // Initial Variables
    dragList: [''], // has the value of the selected items in sequence from listData
    dragListCopy: [''], // a copy of the listData, but with the selected elements marked with "DragErase" to delete later
    dragErase: Symbol('DragErase') as any, // a symbol to have unique value when deleting
    dragStarted(e: CdkDragStart, dragList: any, dragListCopy: any = '') {
      if (e.source.element.nativeElement.classList.contains('selected')) {
        this.dragList = dragList // reset the dragList
        this.dragListCopy = dragListCopy; // copy listData into variable
      }
    },

    dropListDropped(e: CdkDragDrop<string[]>) {
      if (e.previousContainer === e.container) {
        // If in the same container
        let posAdjust = e.previousIndex < e.currentIndex ? 1 : 0; // Adjusts the placement position
        this.dragListCopy.splice(
          e.currentIndex + posAdjust,
          0,
          ...this.dragList
        ); // put elements in dragListCopy
        this.dragListCopy = this.dragListCopy.filter(
          (el) => el !== this.dragErase
        ); // remove the "DragErase" from the list

        // Pass item by item to final list
        for (let i = 0; i < e.container.data.length; i++) {
          e.container.data[i] = this.dragListCopy[i];
        }
      } else {
        // If in different containers

        // remove the "DragErase" from the list
        this.dragListCopy = this.dragListCopy.filter(
          (el) => el !== this.dragErase
        );

        // Pass item by item to initial list
        for (let i = 0; i < e.previousContainer.data.length; i++) {
          e.previousContainer.data[i] = this.dragListCopy[i];
        }
        this.dragList.forEach(() => {
          e.previousContainer.data.pop();
        });

        let otherListCopy = [...e.container.data]; // list of new container
        otherListCopy.splice(e.currentIndex, 0, ...this.dragList); // put elements in othalert(this.dragErase);erListCopy

        // Pass item by item to final list
        for (let i = 0; i < otherListCopy.length; i++) {
          e.container.data[i] = otherListCopy[i];
        }
      }


      // Remove ".hide"
      let allHidden = document.querySelectorAll('.hide');
      allHidden.forEach((el) => {
        el.classList.remove('hide');
      });
      // Remove ".selected" after 300ms
      setTimeout(() => {
        let allSelected = document.querySelectorAll('.selected');
        allSelected.forEach((el) => {
          el.classList.remove('selected', 'last');
        });
      }, 300);

      this.dragListCopy = []; // reset the dragListCopy
      this.dragList = []; // reset the dragList
    },
  };



  close() {
    this.closeShip.emit(this.tab);
    document.body.style.overflow = "auto";
  }

  valuechange(value: any) {

    if (value && !this.viewModel.selectdShip.includes(value) && !this.viewModel.addShipList.includes(value)) {
      this.viewModel.selectdShip.push(value);
      this.refreshSearchFiled();
    }
   
  }
  checkTempShip(value: string) {
    let index = this.viewModel.shipsFromDragListTemp.indexOf(value);
    if (!this.viewModel.shipsFromDragListTemp.includes(value)) {
      this.viewModel.shipsFromDragListTemp.push(value);
    }
    else {
      this.viewModel.shipsFromDragListTemp.splice(index, 1);
    }

    this.viewModel.shipsFromdragListCopyTemp = [...this.viewModel.selectdShip];
    this.viewModel.shipsFromDragListTemp.forEach((el: string) => {
      let index = this.viewModel.shipsFromdragListCopyTemp.indexOf(el);
      this.viewModel.shipsFromdragListCopyTemp.splice(index, 1);
    });


  }
  shipFormTempSelected(item: any) {
    if (this.viewModel.shipsFromDragListTemp.includes(item)) {
      return true;
    }
    return false;
  }

  moveShip() {
    if (this.viewModel.shipsFromDragListTemp.length > 0) {
      for(let el of this.viewModel.shipsFromDragListTemp) {
        const result = this.viewModel.imosNew.filter(s => s.vslNumber == el);
        this.addShip(result[0]);
      }
      this.viewModel.addShipList = [...this.viewModel.addShipList,...this.viewModel.shipsFromDragListTemp];
      this.viewModel.selectdShip = [...this.viewModel.shipsFromdragListCopyTemp];
      this.viewModel.shipsFromDragListTemp = [];
    }
  }

  getShipDetails(value: string) {
    let result = this.viewModel.imosNew.filter(s => s.vslNumber == value);
    return result[0]['vslName'];
  }

  selectedDate(event: any, index: number) {
    let selectDate = new Date(event);
    let effectiveFormDate = selectDate.getDate().toString().padStart(2, "0") + '.' + (selectDate.getMonth() + 1).toString().padStart(2, "0") + '.' + selectDate.getFullYear();
    const control = <UntypedFormArray>this.ShipForm.get('ships');
    control.controls[index].patchValue({ 'effectiveForm': effectiveFormDate })
  }

  getReferralsFormArr(index: any): UntypedFormGroup {
    return this.shipFormGroups.controls[index] as UntypedFormGroup;
  }

  isError(index: number) {
    const ships = <UntypedFormArray>this.ShipForm.get('ships');
    return ships.controls[index].get('vslNumber')?.errors;
  }

  deleteShip(i: number, vslNumber: string) {
    this.shipFormGroups.removeAt(i);

    if (vslNumber && this.viewModel.addShipList.includes(vslNumber)) {
      let index = this.viewModel.addShipList.indexOf(vslNumber);
      this.viewModel.addShipList.splice(index, 1);
      this.refreshSearchFiled();
    }
  }

  refreshSearchFiled() {
    let shipsData: any = [];
    this.viewModel.searchInput = false;
    this.viewModel.imosNewTemp.forEach((ele: any) => {
      let vslNumberExist:any = shipsData.find((x:any) =>   x.id  === ele.vslNumber );
    
      if (ele.vslName && !vslNumberExist && (!this.viewModel.selectdShip.includes(ele.vslNumber) && !this.viewModel.addShipList.includes(ele.vslNumber))) {
        let name = this.convertFirstLetterToUpperCase(ele.vslName) + ' (' + ele.vslNumber + ')';
        shipsData.push({  id: ele.vslNumber , name: name});
      }
    });
    this.viewModel.shipsData = [];
    this.viewModel.shipsData = shipsData;
    console.log("2",this.viewModel.shipsData)
    let that = this;
    setTimeout(function () {
      that.viewModel.searchInput = true;
    }, 1);
  }

  alreadyExist(event: any, index: number) {
    this._vesselService.validateVessel(event.target.value)
      .subscribe({
        next: (res) => {
          if (res.data.validateVessel.success) {
            const ships = <UntypedFormArray>this.ShipForm.get('ships');
            ships.controls[index].get('vslNumber')?.setErrors({ 'alreadyExist': true });
          }
          else if (!res.data.validateVessel.gvsls) {
            const ships = <UntypedFormArray>this.ShipForm.get('ships');
            ships.controls[index].get('vslNumber')?.setErrors({ 'vslNotFoundInImos': true });
          }
        }
      });
  }

  saveShip() {
    let vesselSubpool:any = [];
    this.viewModel.addShipSubmit = true;
    if (this.ShipForm.invalid) {
      return;
    }

    let ships = [...this.ShipForm.value.ships];

   
    ships.forEach((it: any, index: number) => {
      ships[index]['poolPoint'] = parseFloat(it.poolPoint)
      let effectiveForm = it.effectiveForm.split(".");
      let data = new Date(effectiveForm[2] + '-' + effectiveForm[1] + '-' + effectiveForm[0]);
      ships[index]['effectiveForm'] = this.datepipe.transform(data, 'yyyy-MM-dd');
      ships[index]['vslOwner'] = ships[index]['vslOwner'].value;
      ships[index]['fleet'] = this.viewModel.fleet;
      if(vesselSubpool.indexOf(ships[index].subPool) === -1){
        vesselSubpool.push(ships[index].subPool);
      }
     
    });
    this._vesselService.createVessels(ships)
      .subscribe({
        next: (res: any) => {
          if (res.data.createVessel.success) {
            this._storageService.putDataInStorage("listReloadAction", "yes")
            this.close();
            let subpoolMsg = '';
            if(vesselSubpool.length == 1){
              subpoolMsg = 'set to Sub Pool ' + vesselSubpool[0];
            }
            
            this.toasterService.openToast('Success', res.data.createVessel.message + ' ' + subpoolMsg);
          }
        }
      });
  }
  closeSearchShip(){
    let active  =  document.getElementsByClassName('autocomplete-container active');
    if(active.length > 0){
      this.viewModel.searchInput = false;
      let that = this;
      setTimeout(function () {
        that.viewModel.searchInput = true;
      }, 1);
    }
  }

}
